import tabsNavComponent from './tabsNav'

export default (Vue) => {
    Vue.component(tabsNavComponent.name, tabsNavComponent)
}